import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from "react-router-dom";
import { UnauthorizedPage } from "./UnauthorizedPage";
import { NotFoundPage } from "./NotFoundPage";
import ApplicationLayout from "./ApplicationLayout";
import { FC, useMemo } from "react";
import { registerGlobal403Handler } from "am-tax-fe-core";
import { SystemAdminPage } from "./SystemAdminPage/SystemAdminPage";
import { ClientAdminPage } from "./ClientAdminPage/ClientAdminPage";
import { SurveyPage } from "./SurveyPage/SurveyPage";
import { ClientListPage } from "./ClientListPage";
import { useCurrentUser } from "../api/users/userQueries";
import { Spinner, Flex } from "@chakra-ui/react";
import { ClientAccessGuard } from "../components/ClientAccessGuard";

// Component to handle conditional routing based on user type
const HomeRedirect: FC = () => {
    const { data: currentUser, isLoading } = useCurrentUser();

    if (isLoading) {
        return (
            <Flex justify="center" align="center" height="100vh">
                <Spinner size="xl" color="blue.500" />
            </Flex>
        );
    }

    // If user is system admin, go to admin page, otherwise go to client list
    if (currentUser?.isSystemAdmin) {
        return <Navigate to="admin" replace />;
    } else {
        return <Navigate to="client-portals" replace />;
    }
};

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<ApplicationLayout />}>
            <Route index element={<HomeRedirect />} />
            <Route path="client-portals" element={<ClientListPage />} />
            <Route path="admin" element={<SystemAdminPage />}>
                <Route path=":tabId" element={<SystemAdminPage />} />
            </Route>
            <Route path="clients/:clientId">
                <Route
                    index
                    element={
                        <ClientAccessGuard>
                            <Navigate to="dashboard" replace />
                        </ClientAccessGuard>
                    }
                />
                <Route
                    path=":tabId"
                    element={
                        <ClientAccessGuard>
                            <ClientAdminPage />
                        </ClientAccessGuard>
                    }
                />
                <Route
                    path=":tabId/:itemId"
                    element={
                        <ClientAccessGuard>
                            <ClientAdminPage />
                        </ClientAccessGuard>
                    }
                />
            </Route>
            <Route path="survey" element={<SurveyPage />} />
            <Route path="Unauthorized" element={<UnauthorizedPage />} />
            <Route path="404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Route>,
    ),
);

export const PageRoutes: FC = () => {
    useMemo(() => {
        registerGlobal403Handler(() => {
            router.navigate("/Unauthorized");
        });
    }, []);

    return <RouterProvider router={router} />;
};
